import { render, staticRenderFns } from "./TopicDetail.vue?vue&type=template&id=a77e43b2&scoped=true&"
import script from "./TopicDetail.vue?vue&type=script&lang=ts&"
export * from "./TopicDetail.vue?vue&type=script&lang=ts&"
import style0 from "./TopicDetail.vue?vue&type=style&index=0&id=a77e43b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77e43b2",
  null
  
)

export default component.exports